import { compose } from 'redux'
import { createStore, applyMiddleware } from 'redux'
import thunkMiddleware from 'redux-thunk'
import { reduxFirestore } from 'redux-firestore'
import { reactReduxFirebase, getFirebase } from 'react-redux-firebase'
import firebase from 'firebase'
import 'firebase/firestore'

/*
import PouchDB from 'pouchdb'
import { persistentStore } from 'redux-pouchdb'
*/

// Initialize Firebase
const fbConfig = {
  apiKey: "AIzaSyCNRmIfn9SUFs_0k2ISnU5uX9_HplLYS0k",
  authDomain: "report-fe06a.firebaseapp.com",
  databaseURL: "https://report-fe06a.firebaseio.com",
  projectId: "report-fe06a",
  storageBucket: "report-fe06a.appspot.com",
  messagingSenderId: "128620902389"
};

const config = { 
  userProfile: 'users', 
  useFirestoreForProfile: true, 
  attachAuthIsReady: true,
  presence: 'presence',
  sessions: 'sessions',
  //enableLogging: false
}

firebase.initializeApp(fbConfig);
const firestore = firebase.firestore()
const settings = {/* your settings... */ timestampsInSnapshots: true};
firestore.settings(settings);

//firebase.database.enableLogging(true);

/*
const db = new PouchDB('report')

const remoteDB = new PouchDB('http://127.0.0.1:5984/report')
db.sync(remoteDB).on('complete', function () {
  // yay, we're in sync!
  console.log('synced')
}).on('error', function (err) {
  // boo, we hit an error!
  console.log('error')
  console.log(err)
});
*/

export default compose(
  reactReduxFirebase(firebase,config), // used for auth
  reduxFirestore(firebase),
  applyMiddleware(thunkMiddleware.withExtraArgument(getFirebase) )
)(createStore)


//      persistentStore(db)



// WEBPACK FOOTER //
// ./src/configureStore.js